import { useEffect } from "react";
import shared from "./shared";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

export const useSeo = ({ path, title, description, ld }) => {
  useEffect(() => {
    const url = shared.abs(path);
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setLink('link[rel="canonical"]', { rel: "canonical", href: url });
    setLink('link[hreflang="de-DE"]', { rel: "alternate", hreflang: "de-DE", href: url });
    setLink('link[hreflang="x-default"]', { rel: "alternate", hreflang: "x-default", href: url });
    const script = document.getElementById("ld-json");
    if (script && ld) script.textContent = JSON.stringify(ld);
  }, [path, title, description, ld]);
};
